import request from "@/utils/request"

// 菜单列表
export function MenuList() {
  return request({
    url: "/admin/system/menu/findMenuTree",
    method: "GET",
  })
};

// 获取菜单列表
export function MenuNavList() {
  return request({
    url: "/admin/system/menu/findNavTreeAll",
    method: "GET",
  })
};


// 创建菜单
export function CreateMenu(parentId,name,url,perms,path,type,icon,orderNum) {
  return request({
    url: "/admin/system/menu/save",
    method: "POST",
    data: {
      parentId,name,url,perms,path,type,icon,orderNum
    }
  })
};
// 删除菜单
export function DelMenu(id) {
  return request({
    url: `/admin/system/menu/delete`,
    method: "POST",
    data: {
      id
    }
  })
};
//查看菜单信息
export function MenuInfo(id) {
  return request({
    url: `/admin/system/menu/findById`,
    method: "POST",
    data: {
      id
    }
  })
};
// 修改菜单信息
export function upDataMenuInfo(id,parentId,name,url,perms,path,type,icon,orderNum) {
  return request({
    url: `/admin/system/menu/save`,
    method: "POST",
    data: {
      id,parentId,name,url,perms,path,type,icon,orderNum
    }
  })
}
